module.exports = __webpack_public_path__ + "img/24px-printer-white.f0d7ab84.svg";